// extracted by mini-css-extract-plugin
export var chevronIcon = "_8v-2";
export var teamName = "_8v-1";
export var teamSwitcherButton = "_8v-0";